/* eslint-disable */
import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// main components below
import AllItemTable from './Table';
import SearchInventoryFilter from './Filter';
import seturlParams from 'helpers/seturlParams';
import { getBorrowedList } from 'reducers/borrowReturnReducer';

// Modals
import BorrowItemModal from './BorrowItem';

import './style.scss';
import { useEffect } from 'react';

// main component
const AllItem = ({ departmentID, setRefreshTab, refreshTab, activeTab }) => {
  const dispatch = useDispatch();

  const printRef = useRef();

  const [searchData, setSearchData] = useState({
    search: '',
  });

  const [showModal, setShowModal] = useState({
    borrowItem: false,
  });

  const getInventoryRequestList = () => {
    if (activeTab === 'All Item') {
      // This code is to get table list data
      dispatch(
        getBorrowedList({
          department_id: departmentID,
          q: seturlParams(searchData?.search, 'q'),
          per_page: 100000,
        }),
      );
    }
  };

  useEffect(() => {
    if (refreshTab) {
      setSearchData({
        search: '',
      });
    }

    setRefreshTab(false);
  }, [refreshTab]);

  return (
    <div className='admissions-inventory-tab-inventory-items'>
      <SearchInventoryFilter
        printRef={printRef}
        searchData={searchData}
        setShowModal={setShowModal}
        departmentID={departmentID}
        setSearchData={setSearchData}
      />

      <AllItemTable
        printRef={printRef}
        searchData={searchData}
        departmentID={departmentID}
        setSearchData={setSearchData}
        getInventoryRequestList={getInventoryRequestList}
      />

      <BorrowItemModal
        activeTab={activeTab}
        showModal={showModal}
        setShowModal={setShowModal}
        departmentID={departmentID}
        getInventoryRequestList={getInventoryRequestList}
      />
    </div>
  );
};

AllItem.defaultProps = {
  departmentID: '',
};

AllItem.propTypes = {
  departmentID: PropTypes.string,
};

export default AllItem;
